import { useAppVersion } from '../hooks/useAppVersion';

export function UpdateBanner() {
  const { updateAvailable, refresh } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div className="update-banner">
      <span>A new version is available.</span>
      <button onClick={refresh} className="update-banner-btn">
        Refresh Now
      </button>
    </div>
  );
}
